import {
  DELETE_IDEATION,
  FINALIZATION_BY_SPG_DRAFT,
  FINALIZATION_SPG,
  GET_ALL_IDEATION_API,
  GET_ALL_IDEATION_DETAILS,
  GET_ALL_IDEATION_FLOW,
  GET_ALL_MODULE_API,
  GET_DETAIL_MODULE,
  GET_DRAFT_DEMAND_SOLUTION,
  GET_DRAFT_DIFO,
  GET_NOTES_DEMAND_TOUCHPOINT_DRAFT,
  GET_NOTES_GENTA_GENDIS_DRAFT,
  GET_SPG_DRAFT,
  GET_SPG_FINALIZATION_DRAFT,
  GET_SPG_KICKOFF_DRAFT,
  GET_SUMMARY_DATA,
  GOLIVE_SPG,
  HOLD_BY_SPG,
  KICKOFF_BY_SPG,
  KICKOFF_BY_SPG_DRAFT,
  MONITORING,
  PRA_GOLIVE_SPG,
  REJECT_BY_SPG,
  REVISION_BY_GENTA_GENDIS,
  REVISION_BY_SPG,
  REVISION_DEMAND_SOLUTION,
  REVISION_DEMAND_TOUCHPOINT,
  REVISION_DIFO,
  REVISION_FINALIZATION,
  REVISION_KICKOFF,
  SAVE_DRAFT_IDEATION,
  SAVE_IDEATION,
  SUBMIT_PROJECT_DEVELOPMENT,
  VERIFIED_BY_DEMAND_SOLUTION_DRAFT,
  VERIFIED_BY_DEMAND_TOUCHPOINT_DRAFT,
  VERIFIED_BY_GENTA_GENDIS,
  VERIFIED_BY_GENTA_GENDIS_DRAFT,
  VERIFIED_BY_SPG,
  VERIFIED_BY_SPG_DRAFT,
  VERIFIED_DEMAND_SOLUTION,
  VERIFIED_DEMAND_TOUCHPOINT,
  VERIFIED_DIFO,
  VERIFIED_DIFO_DRAFT,
  SEND_ACKNOWLEDGE_DEMANDTOUCHPOINT,
} from "@/api/ideation/ideation";
import querystring from "query-string";

const state = {
  listIdeation: {},
  listModule: {},
  moduleDetail: {},
  detailIdeation: {},
  flowIdeation: {},
  draft: {},
  summary: {},
  typeof: null,
};

const mutations = {
  SET_LIST_IDEATION: (state, payload) => {
    state.listIdeation = payload;
  },
  SET_LIST_MODULE: (state, payload) => {
    state.listModule = payload;
  },
  SET_DETAIL_MODULE: (state, payload) => {
    state.moduleDetail = payload;
  },
  SET_DETAIL_IDEATION: (state, payload) => {
    state.detailIdeation = payload;
  },
  SET_FLOW_IDEATION: (state, payload) => {
    state.flowIdeation = payload;
  },
  SET_NOTES_DRAFT: (state, payload) => {
    state.draft = payload;
  },
  SET_SUMMARY: (state, payload) => {
    state.summary = payload;
  },
  COMMIT_TYPE_IDEATION: (state, payload) => {
    state.typeof = payload;
  },
};

const actions = {
  GET_ALL_IDEATION: async ({ commit }, params) => {
    params = querystring.stringify(params);
    const resp = await GET_ALL_IDEATION_API(params);
    const data = resp.data.data;
    console.log("GET_ALL_IDEATION ===> ", data.data);
    commit("SET_LIST_IDEATION", data);
  },
  GET_ALL_MODULE: async ({ commit }, params) => {
    params = querystring.stringify(params);
    const resp = await GET_ALL_MODULE_API(params);
    const data = resp.data.data;
    commit("SET_LIST_MODULE", data);
  },
  GET_MODULE_DETAIL: async ({ commit }, id) => {
    // params = querystring.stringify(params);
    const resp = await GET_DETAIL_MODULE(id);
    const data = resp.data.data;

    commit("SET_DETAIL_MODULE", data);
  },
  SAVE_NEW_IDEATION: async ({}, args) => {
    return await SAVE_IDEATION(args);
  },
  SAVE_DRAFT_IDEATION: async ({}, args) => {
    return await SAVE_DRAFT_IDEATION(args);
  },
  DELETE_IDEATION: async ({}, args) => {
    return await DELETE_IDEATION(args);
  },
  GET_IDEATION_DETAIL: async ({ commit }, params) => {
    const resp = await GET_ALL_IDEATION_DETAILS(params);
    const data = resp.data.data;
    commit("SET_DETAIL_IDEATION", data);
  },
  GET_IDEATION_FLOW: async ({ commit }, params) => {
    const resp = await GET_ALL_IDEATION_FLOW(params);
    const data = resp.data.data;
    commit("SET_FLOW_IDEATION", data);
  },
  GET_IDEATION_BYID: async ({ commit }, params) => {
    const resp = await GET_ALL_IDEATION_DETAILS(params);
    const data = resp.data.data;
    commit("SET_DETAIL_IDEATION", data);
    return data;
  },

  // DEMAND TOUCHPOINT
  SEND_ACKNOWLEDGE_DEMANDTOUCHPOINT: async ({}, args) => {
    return await SEND_ACKNOWLEDGE_DEMANDTOUCHPOINT(args);
  },

  // GENTA GENDIS
  VERIFIED_BY_GENTA_GENDIS: async ({}, args) => {
    return await VERIFIED_BY_GENTA_GENDIS(args);
  },
  REVISION_BY_GENTA_GENDIS: async ({}, args) => {
    return await REVISION_BY_GENTA_GENDIS(args);
  },
  VERIFIED_BY_GENTA_GENDIS_DRAFT: async ({}, args) => {
    return await VERIFIED_BY_GENTA_GENDIS_DRAFT(args);
  },
  GET_LIST_IDEATION_DRAFT: async ({ commit }, params) => {
    const resp = await GET_NOTES_GENTA_GENDIS_DRAFT(params);
    const data = resp.data.data;
    commit("SET_NOTES_DRAFT", data);
  },

  // DEMAND TOUCHPOINT
  VERIFIED_DEMAND_TOUCHPOINT: async ({}, args) => {
    console.log(args);
    return await VERIFIED_DEMAND_TOUCHPOINT(args);
  },
  REVISION_DEMAND_TOUCHPOINT: async ({}, args) => {
    return await REVISION_DEMAND_TOUCHPOINT(args);
  },
  VERIFIED_BY_DEMAND_TOUCHPOINT_DRAFT: async ({}, args) => {
    return await VERIFIED_BY_DEMAND_TOUCHPOINT_DRAFT(args);
  },
  GET_LIST_DRAFT_NOTES_DEMAND: async ({ commit }, params) => {
    const resp = await GET_NOTES_DEMAND_TOUCHPOINT_DRAFT(params);
    const data = resp.data.data;
    commit("SET_NOTES_DRAFT", data);
  },

  // SPG
  VERIFICATION_BY_SPG: async ({}, args) => {
    return await VERIFIED_BY_SPG(args);
  },
  VERIFICATION_BY_SPG_DRAFT: async ({}, args) => {
    return await VERIFIED_BY_SPG_DRAFT(args);
  },
  GET_SPG_DRAFT: async ({ commit }, params) => {
    const resp = await GET_SPG_DRAFT(params);
    const data = resp.data.data;
    commit("SET_NOTES_DRAFT", data);
  },
  REJECT_BY_SPG: async ({}, args) => {
    return await REJECT_BY_SPG(args);
  },
  REVISION_BY_SPG: async ({}, args) => {
    return await REVISION_BY_SPG(args);
  },
  HOLD_BY_SPG: async ({}, args) => {
    return await HOLD_BY_SPG(args);
  },
  FINALIZATION_SPG: async ({}, args) => {
    return await FINALIZATION_SPG(args);
  },
  REVISION_FINALIZATION: async ({}, args) => {
    return await REVISION_FINALIZATION(args);
  },
  KICKOFF_BY_SPG: async ({}, args) => {
    return await KICKOFF_BY_SPG(args);
  },
  REVISION_KICKOFF: async ({}, args) => {
    return await REVISION_KICKOFF(args);
  },

  FINALIZATION_BY_SPG_DRAFT: async ({}, args) => {
    return await FINALIZATION_BY_SPG_DRAFT(args);
  },
  GET_SPG_FINALIZATION_DRAFT: async ({ commit }, params) => {
    const resp = await GET_SPG_FINALIZATION_DRAFT(params);
    const data = resp.data.data;
    commit("SET_NOTES_DRAFT", data);
  },

  KICKOFF_BY_SPG_DRAFT: async ({}, args) => {
    return await KICKOFF_BY_SPG_DRAFT(args);
  },
  GET_SPG_KICKOFF_DRAFT: async ({ commit }, params) => {
    const resp = await GET_SPG_KICKOFF_DRAFT(params);
    const data = resp.data.data;
    commit("SET_NOTES_DRAFT", data);
  },

  // Demand Solution
  VERIFIED_DEMAND_SOLUTION: async ({}, args) => {
    return await VERIFIED_DEMAND_SOLUTION(args);
  },
  VERIFIED_BY_DEMAND_SOLUTION_DRAFT: async ({}, args) => {
    return await VERIFIED_BY_DEMAND_SOLUTION_DRAFT(args);
  },
  GET_DRAFT_DEMAND_SOLUTION: async ({ commit }, params) => {
    const resp = await GET_DRAFT_DEMAND_SOLUTION(params);
    const data = resp.data.data;
    commit("SET_NOTES_DRAFT", data);
  },
  REVISION_DEMAND_SOLUTION: async ({}, args) => {
    return await REVISION_DEMAND_SOLUTION(args);
  },

  // DIFO
  VERIFIED_DIFO: async ({}, args) => {
    return await VERIFIED_DIFO(args);
  },
  VERIFIED_DIFO_DRAFT: async ({}, args) => {
    return await VERIFIED_DIFO_DRAFT(args);
  },
  GET_DRAFT_DIFO: async ({ commit }, params) => {
    const resp = await GET_DRAFT_DIFO(params);
    const data = resp.data.data;
    commit("SET_NOTES_DRAFT", data);
  },
  SUBMIT_PROJECT_DEVELOPMENT: async ({}, args) => {
    return await SUBMIT_PROJECT_DEVELOPMENT(args);
  },
  REVISION_DIFO: async ({}, args) => {
    return await REVISION_DIFO(args);
  },

  // PRA GO LIVE
  PRA_GOLIVE_SPG: async ({}, args) => {
    return await PRA_GOLIVE_SPG(args);
  },

  //GO LIVE
  GOLIVE_SPG: async ({}, args) => {
    return await GOLIVE_SPG(args);
  },

  // Monitoring
  MONITORING: async ({}, args) => {
    return await MONITORING(args);
  },

  // Summary
  GET_SUMMARY_DATA: async ({ commit }) => {
    const resp = await GET_SUMMARY_DATA();
    const data = resp.data.data;
    commit("SET_SUMMARY", data);
  },
};

const getters = {
  listIdeation: (state) => state.listIdeation,
  listModule: (state) => state.listModule,
  detailModule: (state) => state.moduleDetail,
  detailIdeation: (state) => state.detailIdeation,
  flowIdeation: (state) => state.flowIdeation,
  notesDraft: (state) => state.draft,
  summaryData: (state) => state.summary,
  typeOf: (state) => state.typeof,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
